import React from 'react';
import { Table, Empty, Tooltip,Tag,Input, Checkbox, Form} from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';

export default function Resumen(props) {
    const _liStyle = {fontWeight:'bold'}

    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.id}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Moneda',
                        dataIndex: 'moneda',
                        key: 'moneda',
                        align: 'center',
                
                    },
                    {
                        title: 'Total Efectivo',
                        dataIndex: 'totalEfectivo',
                        key: 'totalEfectivo',
                        align: 'right',

                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )

                    },
                    {
                        title: 'Total Caja',
                        dataIndex: 'totalCaja',
                        key: 'totalCaja',
                        align: 'right',
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )

                    },
                    {
                        title: 'Sobrante o Faltante',
                        dataIndex: 'totalfaltante',
                        key: 'totalfaltante',
                        align: 'center',
                        render: (value,row) => {
                            return (<div className="custom-options" >
                                {(() => {
                                    if(value ===0){
                                        return <Tag color={"black"}>{value.toFixed(2)}</Tag>;
                                    }
                                    if(value > 0){
                                        return <Tag color={"green"}>{value.toFixed(2)}</Tag>;

                                    }
                                    if(value < 0){
                                        return <Tag color={"red"}>{value.toFixed(2)}</Tag>;
 
                                    }
                              
                                })()}
    
                            </div>)
                        }
                    

                    },
                    {
                        title: 'Ajuste',
                        dataIndex: 'totalfaltante',
                        key: 'totalfaltante',

                        render: (value,row) => {
                            return (<div className="custom-options" >
                                {(() => {
                                    if(value ===0){
                                        return <span color={"black"}>{value.toFixed(2)}</span>;
                                    }
                                    if(value > 0){
                                        return <span color={"green"}>({value.toFixed(2)})</span>;

                                    }
                                    if(value < 0){
                                        return <span color={"red"}>{value.toFixed(2)}</span>;
 
                                    }
                              
                                })()}
    
                            </div>)
                        }

                   /*      render: (value, row,index) => {
                            return (
                                <Form.Item>
                                {props.onGetFieldDecorator(`arrCantidad[${row.id}]`, {
                                    initialValue: parseFloat(value).toFixed(2),
                                    rules: [
                                        {
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }
                                    ]
                                })(
                                    <Input
                                       // onKeyPress={global.onKeyPressDecimals}
                                       disabled={row.opcion}
                                        placeholder="Cantidad"
                                        autoComplete="off"
                                        className="text-right"
                                        onBlur={(e) => props.onCalculateDetail(row, "arrCantidad", e.target.value, 3,index)}
                                    />
                                )}
                            </Form.Item>
                            );
                        } */
                    },
                    
                    {
                        title: 'Seleccionar',
                        dataIndex: 'opcion',
                        key: 'opcion',
                        align: 'right',
                        className:'hide',
                        render: (value, row) => {
                            return <Checkbox  checked={value} onChange={(e) => props.updateShow(row, e.target.checked)}></Checkbox>
                        }

                    }
                ]}
            />
        </div>
    );
}